export const verticalBreakpoints = {
  largeDesktop: {
    breakpoint: { max: 10000, min: 1100 },
    items: 4,
    slidesToSlide: 3,
    partialVisibilityGutter: 20,
  },
  desktop: {
    breakpoint: { max: 1100, min: 900 },
    items: 3,
    slidesToSlide: 2,
    partialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: { max: 900, min: 464 },
    items: 2,
    slidesToSlide: 2,
    partialVisibilityGutter: 40,
  },
  mobile: {
    breakpoint: { max: 464, min: 200 },
    items: 1,
    slidesToSlide: 1,
    partialVisibilityGutter: 60,
  },
  smallMobile: {
    breakpoint: { max: 200, min: 0 },
    items: 1,
    slidesToSlide: 1,
    partialVisibilityGutter: 0,
  },
};

export const horizontalBreakpoints = {
  mobile: {
    breakpoint: { max: 10000, min: 300 },
    items: 1,
    slidesToSlide: 1,
    partialVisibilityGutter: 60,
  },
  smallMobile: {
    breakpoint: { max: 300, min: 0 },
    items: 1,
    slidesToSlide: 1,
    partialVisibilityGutter: 0,
  },
};
